//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { AESEncrypt }  from '../util/secret.js'
export default {
  props: {
    bookData: Object,
    border: Boolean,
    txtDiff: Boolean
  },
  data() {
    return {
      defaultUrl: require('../assets/img/bookBg.jpg')
    }
  },
  methods: {
    getImgFromISBN(isbn) {
      return `https://store.library3.cn/api/image/get?data=${AESEncrypt(JSON.stringify({"isbn": isbn}))}`;
    },
    handleClick(bookData) {
      this.$emit('handleClick',{
        isbn: bookData.isbn,
        marcid: bookData.marcid
      },bookData);
    }
  },
  beforeMount() {
    this.$Lazyload.config({
      error: require('../assets/img/bookBg.jpg'),
      loading: require('../assets/img/bookBg.jpg')
    })
  }
}
